export const FETCH_SESSION_BEGIN   = 'FETCH_SESSION_BEGIN';
export const FETCH_SESSION_SUCCESS = 'FETCH_SESSION_SUCCESS';
export const FETCH_SESSION_FAILURE = 'FETCH_SESSION_FAILURE';


const fetchSessionBegin = () => ({
  type: FETCH_SESSION_BEGIN
});

const fetchSessionSuccess = userdata => ({
  type: FETCH_SESSION_SUCCESS,
  payload: { ...userdata }
});

const fetchSessionFailure = error => ({
  type: FETCH_SESSION_FAILURE,
  payload: { error }
});

function fetchSession( ) {
	return dispatch => {
		
		dispatch(fetchSessionBegin());
		return fetch( '/user/index/userdata' )
			.then(res => res.json())
			.then(result => {
				if( result.sessiondata ){
					var sessiondata = result.sessiondata;
					if( sessiondata ){
						dispatch( fetchSessionSuccess(sessiondata) );
					}else{
						dispatch(fetchSessionFailure(result));
					}
				}else{
					try{
						setTimeout(function(){
							popLoginDialog();
						},3000);
						
					}catch(e){
						console.log("未登录");
					}
				}
				return result;
			})
			.catch(error => dispatch(fetchSessionFailure(error)));
	};
}

export {
	fetchSession,
	fetchSessionBegin,
	fetchSessionSuccess,
	fetchSessionFailure	
}